<unity-modal [title]="title"
        [primaryAction]="btnOkText"
        (onPrimaryAction)="accept()"
        (onClose)="dismiss()">
    <ep-panel panelType="transparent">
        <ep-row>
            <div
                class="col-12"
                style="display: inline-block; max-width: 100%; margin-bottom: 10px; white-space: pre-line"
            >
                {{ message }}
            </div>
        </ep-row>
    </ep-panel>
</unity-modal>